// language=GraphQL
export const ALL_ESIM_REGIONS_QUERY = `query Query {
  esimRegions: ratioEsimRegions {
    id
    name
    serviceCodePrefix
  }
}`

// language=GraphQL
export const SINGLE_ESIM_REGION_QUERY = `query Query($id: ID!) {
  esimRegion: ratioEsimRegion(id: $id) {
    id
    name
    serviceCodePrefix
  }
}`

// language=GraphQL
export const CREATE_ESIM_REGION_MUTATION = `
  mutation Mutation($input: CreateRatioEsimRegionInput) {
    esimRegion: createRatioEsimRegion(input: $input) {
      id
      name
      serviceCodePrefix
    }
  }`

// language=GraphQL
export const UPDATE_ESIM_REGION_MUTATION = `
  mutation Mutation($input: UpdateRatioEsimRegionInput) {
    esimRegion: updateRatioEsimRegion(input: $input) {
      id
      name
      serviceCodePrefix
    }
  }`

// language=GraphQL
export const DELETE_ESIM_REGION_MUTATION = `
  mutation Mutation($input: DeleteRatioEsimRegionInput) {
    deleteRatioEsimRegion(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ESIM_REGION_MUTATION = `
  mutation Mutation($input: DeleteRatioEsimRegionInput) {
    forceDeleteRatioEsimRegion(input: $input) {
      success
    }
  }`
// language=GraphQL
export const ESIM_REGIONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withRatioEsimConfigs: Boolean = false, $withTravelEsimSettings: Boolean = false) {
  groupedDependents: ratioEsimRegionDependents(id: $id) {
    ratioEsimConfigs @include(if: $withRatioEsimConfigs) {
      id
      enabled
    }
    travelEsimSettings @include(if: $withTravelEsimSettings) {
      id
      enabled
    }
  }
}`
